export default {
  setTractVisitTypes (state, tractVisitTypes) {
    state.tractVisitTypes = tractVisitTypes
  },

  addTractVisitType (state, tractVisitType) {
    state.tractVisitTypes.push(tractVisitType)
  },

  removeTractVisitType (state, tractVisitTypeId) {
    state.tractVisitTypes = state.tractVisitTypes.filter(t => t.tractVisitTypeId !== tractVisitTypeId)
  },

  updateTractVisitType (state, tractVisitType) {
    const index = state.tractVisitTypes.findIndex(t => t.tractVisitTypeId === tractVisitType.tractVisitTypeId)
    if (index !== -1) {
      Object.assign(state.tractVisitTypes[index], tractVisitType)
    }
  }
}
